import SeoHead from "../components/seo/SeoHead";
import StructuredData from "../components/seo/StructuredData";
import TheQAHubAcademyImage from "../images/TheQAHubAcademy.png";
import { useTranslation } from "../i18n";
import { renderBrandText } from "../utils/brandText";
import { breadcrumbSchema, organizationSchema, schemaGraph } from "../utils/seoData";
import "./Academy.css";

function Academy() {
    const { t } = useTranslation();

    return (
        <div className="academy-page">
            <SeoHead
                title={t("academy.metaTitle")}
                description={t("academy.metaDescription")}
                canonicalPath="/academy"
            />
            <StructuredData
                data={schemaGraph([
                    organizationSchema(TheQAHubAcademyImage),
                    breadcrumbSchema([
                        { name: t("nav.home"), url: "/" },
                        { name: t("academy.kicker"), url: "/academy" },
                    ]),
                ])}
            />

            <section className="academy-bridge-page">
                <div className="academy-bridge-card">
                    <span className="academy-bridge-kicker">{t("academy.kicker")}</span>
                    <h1>{t("academy.title")}</h1>
                    <p>
                        {t("academy.bodyPrefix")}
                        <strong> academy.theqahub.es</strong>
                        {t("academy.bodySuffix")}
                    </p>
                    <div className="academy-bridge-actions">
                        <a href="https://academy.theqahub.es" className="academy-bridge-btn" target="_blank" rel="noreferrer">
                            {t("academy.cta")}
                        </a>
                    </div>
                    <div className="academy-bridge-pills">
                        <span>{t("academy.pillCourses")}</span>
                        <span>{t("academy.pillRoadmap")}</span>
                        <span>{t("academy.pillChallenges")}</span>
                        <span>{t("academy.pillExperience")}</span>
                    </div>
                </div>

                <div className="academy-legacy-card">
                    <div className="academy-legacy-copy">
                        <span className="academy-bridge-kicker">{t("academy.legacyKicker")}</span>
                        <h2>{t("academy.legacyTitle")}</h2>
                        <p>
                            {t("academy.legacyBodyPrefix")}
                            <strong> theqahub.es</strong>
                            {t("academy.legacyBodySuffix")}
                        </p>
                        <p>
                            {renderBrandText(t("academy.legacyBody2"))}
                        </p>
                    </div>
                    <div className="academy-bridge-actions academy-legacy-actions">
                        <a href="/academy-legacy" className="academy-bridge-btn academy-bridge-btn-outline">
                            {t("academy.legacyCta")}
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Academy;
